module.exports = "pegasus/assets/column-16-basic.png";